import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView, trackEvent } from "../lib/analytics";

export function AnalyticsTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    initAnalytics();
    const via = new URLSearchParams(window.location.search).get("via");
    if (via) trackEvent("AffiliateReferredVisit", { via, landing: window.location.pathname });
  }, []);
  useEffect(() => { trackPageView(pathname + search); }, [pathname, search]);
  return null;
}
